export default __webpack_public_path__ + "static/media/NirmalLogo.f9a0e4c9.png";